import { Divider } from '@mui/material';
import React from 'react';
import colors from 'src/theme/colors';

export default function GlnDivider() {
  return (
    <Divider
      orientation="vertical"
      sx={{
        height: '24px',
        borderLeft: 'dotted thick',
        borderRight: 'None',
        ml: '16px',
        color: colors.grayInactive,
      }}
    />
  );
}
